// Service for Monthly Cuts — Concept Generation (ASIS-4969)
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type {
  LC_StartConceptGenerationIn,
  LC_StartConceptGenerationOut,
  LC_GetConceptGenerationProgressOut,
  StartConceptGenerationInput,
  ConceptGenerationProgress,
} from '../types';
import { mapConceptGenerationProgress } from '../mappers';


export class MonthlyCutsConceptGenerationService {
  // POST /v1/monthlycuts/concept-generation
  // Encola la generación de conceptos para uno o varios cortes. Los cortes Cerrados o no
  // encontrados se reportan en skippedCutIds / notFoundCutIds en la respuesta (202).
  async start(
    input: StartConceptGenerationInput,
    signal?: AbortSignal,
  ): Promise<ApiResponse<LC_StartConceptGenerationOut>> {
    const body: LC_StartConceptGenerationIn = {
      monthlyCutIds: input.monthlyCutIds,
      employeeIds:
        input.employeeIds && input.employeeIds.length > 0
          ? input.employeeIds.join(',')
          : undefined,
    };

    return apiClient.post<LC_StartConceptGenerationOut>(
      API_CONFIG.ENDPOINTS.MONTHLY_CUTS_CONCEPT_GENERATION,
      body,
      { signal },
    );
  }

  // GET /v1/monthlycuts/{monthlyCutId}/concept-generation/progress
  async getProgress(
    monthlyCutId: number,
    signal?: AbortSignal,
  ): Promise<ApiResponse<ConceptGenerationProgress>> {
    const response = await apiClient.get<LC_GetConceptGenerationProgressOut>(
      API_CONFIG.ENDPOINTS.MONTHLY_CUTS_CONCEPT_GENERATION_PROGRESS(monthlyCutId),
      { signal },
    );

    if (response.success && response.data) {
      return { success: true, data: mapConceptGenerationProgress(response.data) };
    }

    return { success: false, data: null, error: response.error };
  }
}

export const monthlyCutsConceptGenerationService = new MonthlyCutsConceptGenerationService();
